// import { HttpClient } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { firstValueFrom } from 'rxjs';
// import { environment } from '../../environments/environment';
import { ApiMembresiaResponse } from '../../types/API.types';
import { Category } from '../../types/category.types';
import { preloadedCategoriasDestacadas } from '../../data-preloaded/categorias-destacadas-data';
import { preloadedProductosDestacados } from '../../data-preloaded/productos-destacados-data';

// RESOLVERS
export async function getGruposSubcategoriasDestacados(): Promise<
  ApiMembresiaResponse<Category[]>
> {
  try {
    // const http = inject(HttpClient);
    // const url = `${environment.apiUrl}/${environment.apiVersion}${environment.endpoints.categorias.subcategoriasDestacados}`;
    return {
      success: true,
      message: 'Grupos subcategorias destacadas obtenidas correctamente',
      data: preloadedCategoriasDestacadas,
    };
    // return await firstValueFrom(
    //   http.get<ApiMembresiaResponse<Category[]>>(url)
    // );
  } catch (error) {
    console.error(
      '❌ Error obteniendo grupos subcategorias destacados:',
      error
    );
    const response: ApiMembresiaResponse<Category[]> = {
      success: false,
      message: 'Error obteniendo grupos subcategorias destacados',
      data: [],
    };
    return response;
  }
}

export async function getGruposProductosDestacados(): Promise<
  ApiMembresiaResponse<Category[]>
> {
  try {
    // const http = inject(HttpClient);
    // const url = `${environment.apiUrl}/${environment.apiVersion}${environment.endpoints.categorias.productosDestacados}`;
    return {
      success: true,
      message: 'Grupos productos destacadas obtenidas correctamente',
      data: preloadedProductosDestacados,
    };
    // return await firstValueFrom(
    //   http.get<ApiMembresiaResponse<Category[]>>(url)
    // );
  } catch (error) {
    console.error('❌ Error obteniendo grupos productos destacados:', error);
    const response: ApiMembresiaResponse<Category[]> = {
      success: false,
      message: 'Error obteniendo grupos productos destacados',
      data: [],
    };
    return response;
  }
}
